import ky, { isHTTPError } from "ky";

export const client = ky.create({
  hooks: {
    beforeError: [
      ({ error, request }) => {
        // Avoid intercepting errors from the health check endpoint itself
        const isHealthCheck = request.url.includes("/util/health-check");
        const isAbortError = error.name === "AbortError";
        if (!isHealthCheck && !isAbortError) {
          // Check if there is an HTTP response (HTTPError)
          const response = isHTTPError(error) ? error.response : undefined;

          // Trigger server unhealthy event if there is no response (network offline/refused)
          // or if the server returns a down status code (502 Bad Gateway, 503 Service Unavailable, 504 Gateway Timeout)
          if (!response || [502, 503, 504].includes(response.status)) {
            window.dispatchEvent(new CustomEvent("server-unhealthy"));
          }
        }
        return error;
      },
    ],
  },
  prefix: import.meta.env.VITE_YOGI_POKE_API_URL,
  retry: 0,
});
